module.exports = __webpack_public_path__ + "img/hide.9f6cce4b.svg";